import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { DataFeedsFormSection } from '../common/DataFeedsFormSection';
import { RawDataForm } from '../common/RawDataForm';
import { MessageTypeSelect, SettingsSectionHeader } from '../common';
import { SETTINGS_DISPLAY_CONTENT } from './constants';
import {
  ActionButtons,
  BadgeCount,
  BodyTextArea,
  CustomSound,
  DeepLinks,
  DeliverSilently,
  InterruptionSelect,
  OpenAction,
  RelevanceScore,
  RichMedia,
  Title,
  WakeUp,
} from './formFields';
import { displayContent } from '../common/content';
import { useQueryParamContext } from '../context/QueryParamContext';
import { TemplateNameField } from '../common/TemplateNameField';

export const SettingsForm = () => {
  const featureFlags = useSelector(selectFeatureFlags);
  const { campaignId } = useQueryParamContext();
  const isCampaignFlow = !!campaignId;

  return (
    <>
      {isCampaignFlow && (
        <>
          <SettingsSectionHeader>{displayContent.templateInformation}</SettingsSectionHeader>
          <TemplateNameField />
        </>
      )}

      <SettingsSectionHeader>
        {SETTINGS_DISPLAY_CONTENT.sectionHeaders.sendingInformation}
      </SettingsSectionHeader>

      <MessageTypeSelect />

      {featureFlags.IOSInterruptionLevel && <InterruptionSelect />}

      {featureFlags.IOSRelevanceScore && <RelevanceScore />}

      <BadgeCount />

      <WakeUp />

      <DeliverSilently />

      <SettingsSectionHeader>
        {SETTINGS_DISPLAY_CONTENT.sectionHeaders.content}
      </SettingsSectionHeader>

      <Title />

      <BodyTextArea />

      <RichMedia />

      <DataFeedsFormSection />

      <SettingsSectionHeader>
        {SETTINGS_DISPLAY_CONTENT.sectionHeaders.behavior}
      </SettingsSectionHeader>

      <OpenAction />

      <DeepLinks />

      <ActionButtons />

      <CustomSound />

      <RawDataForm />
    </>
  );
};

export default SettingsForm;
